import { Switch as DxSwitch } from "devextreme-react/switch";
import includes from "lodash/includes";
import styled from "styled-components";
const SIZES = {
    LG_WIDTH: 50,
    LG_HEIGHT: 30,
    LG_BORDER_RADIUS: 17,
    LG_SWITCH_HANDLE_SIZE: 28,
    MD_WIDTH: 40,
    MD_HEIGHT: 24,
    MD_BORDER_RADIUS: 100,
    MD_SWITCH_ON_HANDLE_SIZE: 18,
    MD_SWITCH_OFF_HANDLE_SIZE: 12
};
export default {
    Switch: styled(DxSwitch).withConfig({
        shouldForwardProp: (prop) => !includes(["size"], prop)
    }) `
    &,
    &.dx-state-hover,
    &.dx-state-focused,
    &.dx-state-active,
    &.dx-state-active.dx-state-focused {
      width: ${SIZES.LG_WIDTH}px;
      height: ${SIZES.LG_HEIGHT}px;
      .dx-switch-container {
        background-color: ${({ theme }) => theme["toggle-bg"]};
        border-radius: ${SIZES.LG_BORDER_RADIUS}px;
        border: 2px solid ${({ theme }) => theme["toggle-border"]};
        height: ${SIZES.LG_HEIGHT}px;
        width: ${SIZES.LG_WIDTH}px;
        padding: 0 0 0 3px;
      }

      &.dx-switch-on-value {
        .dx-switch-container {
          background-color: ${({ theme }) => theme["toggle-bg-active"]};
          padding: 0 3px 0 0;
          border-color: transparent;
        }
      }

      &,
      &.dx-switch-on-value {
        .dx-switch-handle {
          margin-top: 0;
          width: ${SIZES.LG_SWITCH_HANDLE_SIZE}px;
          height: ${SIZES.LG_SWITCH_HANDLE_SIZE}px;
          flex-basis: ${SIZES.LG_SWITCH_HANDLE_SIZE}px;
          &:before {
            background-color: ${({ theme }) => theme["toggle-handle-bg-active"]};
            border-radius: 50%;
          }
        }
      }

      ${({ size }) => size === "md" &&
        `
        width: ${SIZES.MD_WIDTH}px;
        height: ${SIZES.MD_HEIGHT}px;

        .dx-switch-container {
          width: ${SIZES.MD_WIDTH}px;
          height: ${SIZES.MD_HEIGHT}px;
          border-radius: ${SIZES.MD_BORDER_RADIUS}px;
        }

        .dx-switch-handle {
          margin-top: 4px;
          width: ${SIZES.MD_SWITCH_OFF_HANDLE_SIZE}px;
          height: ${SIZES.MD_SWITCH_OFF_HANDLE_SIZE}px;
          flex-basis: ${SIZES.MD_SWITCH_OFF_HANDLE_SIZE}px;
            &:before {
            background-color: #C8D2DA;
          }
        }

        &.dx-switch-on-value .dx-switch-handle {
          margin-top: 1px;
          width: ${SIZES.MD_SWITCH_ON_HANDLE_SIZE}px;
          height: ${SIZES.MD_SWITCH_ON_HANDLE_SIZE}px;
          flex-basis: ${SIZES.MD_SWITCH_ON_HANDLE_SIZE}px;   
        }
      `}
    }
  `
};
